export function getUserAgent() {
  let ua = "";
  try {
    if ("undefined" != typeof navigator && navigator) {
      ua = navigator.userAgent || "";
    }
  } catch (e) {
    ua = "";
  }
  return ua;
}
function getEnvironment() {
  const ua = getUserAgent();
  var isWindowsPhone = /(?:Windows Phone)/.test(ua),
    isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,
    isAndroid = /(?:Android)/.test(ua),
    isHarmony = ua.indexOf("Harmony") > -1, //鸿蒙终端
    isFireFox = /(?:Firefox)/.test(ua),
    isTablet =
      /(?:iPad|PlayBook)/.test(ua) ||
      (isAndroid && !/(?:Mobile)/.test(ua)) ||
      (isFireFox && /(?:Tablet)/.test(ua)),
    isPhone = /(?:iPhone)/.test(ua) && !isTablet,
    isPc = !isPhone && !isAndroid && !isSymbian;

  const isIos = /ip(ad|hone|od)/i.test(ua);
  const isMobile = isAndroid || isIos;

  return {
    isAndroid: isAndroid || isHarmony,
    isIos,
    isHarmony,
    isMobile,
    isTablet,
    isPhone,
    isPc,
  };
}
//下载地址
const downloadConfig = {
  kalliuWorldGoogle:
    "https://play.google.com/store/apps/details?id=com.joltrix.girlstown.dollhouse.design.makeup.games",
  gameWorldGoogle:
    "https://play.google.com/store/apps/details?id=com.sinyee.babybus.gameworld.design.home.friends.fun.life.story&hl=en_SG",
  gameWorldOverseasIos:
    "https://apps.apple.com/jp/app/game-world-%E3%83%A9%E3%82%A4%E3%83%95%E3%82%B9%E3%83%88%E3%83%BC%E3%83%AA%E3%83%BC/id6557045941",
  gameWorldIos:
    "https://apps.apple.com/cn/app/%E5%88%9B%E6%84%8F%E4%B8%96%E7%95%8C-%E6%A8%A1%E6%8B%9F%E5%88%9B%E9%80%A0%E6%88%91%E7%9A%84%E8%BF%B7%E4%BD%A0%E4%B8%96%E7%95%8C/id6744343384",
  tencentAppUrl: "https://sj.qq.com/appdetail/com.joltrix.bingoworld",
  tapUrl: "https://www.taptap.cn/app/856059?os=android",
};
const mediaConfig = {
  xhs: "https://www.xiaohongshu.com/user/profile/676391fa0000000018032ad5?xsec_token=ABkQHp90gr37iZMKmSX6a8c6DE8HbkVD2x9BypC_ggNUc%3D&xsec_source=pc_search",
  dy: "https://www.douyin.com/user/MS4wLjABAAAAR8pIf-UTOjxpciaPcEklvoCoNDlMVJnf7qkjSs9ZHRBhNhpjvjMujRndnQFoOzLQ?previous_page=app_code_link",
  ks: "https://www.kuaishou.com/profile/3xdfdgwjyycf6z4",
  tiktok: "https://www.tiktok.com/@gameworld.lifestory",
  youtube: "https://www.youtube.com/@gameworld.lifestory",
};
const langToText = {
  zh: "中文",
  en: "英语",
  pt: "葡语",
  ar: "阿语",
  vi: "越南语",
  es: "西语",
};

export const useAppState = () => {
  const { locale } = useI18n();
  let conn: any = undefined;
  if (import.meta.client) {
    conn =
      (navigator as any).connection ||
      (navigator as any).mozConnection ||
      (navigator as any).webkitConnection;
  }
  const isOverseas = useState<boolean>(
    "is-overseas",
    () => locale.value !== "zh",
  );

  return {
    isOverseas,
    langText: langToText[locale.value],
    downloadConfig,
    mediaConfig,
    networktype: conn
      ? conn?.effectiveType === "wifi"
        ? "wifi"
        : "流量"
      : "未知",
    environment: getEnvironment(),
  };
};
